import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Forbidden from "pages/Forbidden";
import ServicesZone from 'pages/ServicesZone'; 
import NotFound from "pages/NotFound";
import LandingPage from './pages/landing-page';
import AnalyticsDashboard from './pages/analytics-dashboard';
import ServiceCatalogManager from './pages/service-catalog-manager';
import DispatchControlCenter from './pages/dispatch-control-center';
import PublicServiceTracking from './pages/public-service-tracking';
import MesDevisPage from './pages/mes-devis';
import PublicQuotePage from './pages/public-quote';
import QuoteAcceptBookingPage from './pages/quote-accept-booking';
import LoginAuthentication from './pages/login-authentication';
import ServiceBookingWizard from './pages/service-booking-wizard';
import TechnicianDailyRoutes from './pages/technician-daily-routes';
import CustomerAccountPortal from './pages/customer-account-portal';
import AuthCallback from './pages/auth-callback';
import ProtectedRoute from "components/ProtectedRoute.jsx";
import UserManagement from "pages/user-management-and-role-administration";
import InterventionPage from './pages/Intervention-page';
import InventoryManagement from './pages/inventory-management';
import ServiceAndChecklist from './pages/service-and-checklist';
import Interventionmanagement from './pages/interventions-management';
import PrivacyPolicy from './pages/privacy-policy';
import FaqPage from './pages/faq';
import CgvPage from './pages/cgv';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/unauthorized" element={<Forbidden />} />

          <Route path="/" element={<LandingPage />} />
          {/* <Route path="/landing-page" element={ <LandingPage /> } /> */}
          <Route path="/analytics-dashboard" element={<ProtectedRoute allowedRoles={['admin','manager']}><AnalyticsDashboard /></ProtectedRoute>} />
          <Route path="/service-catalog-manager" element={<ProtectedRoute allowedRoles={['admin','dispatch','trainer','manager']}><ServiceCatalogManager /></ProtectedRoute>} />
          <Route path="/dispatch-control-center" element={<ProtectedRoute allowedRoles={['admin','dispatch','manager']}><DispatchControlCenter /></ProtectedRoute>} />
          <Route path="/services-zone" element={<ProtectedRoute allowedRoles={['admin','dispatch','manager']}><ServicesZone /></ProtectedRoute>} />
          <Route path="/intervention-page/:id" element={<ProtectedRoute allowedRoles={['technicien']}><InterventionPage /></ProtectedRoute>} />
          <Route path="/checklist-service" element={<ProtectedRoute allowedRoles={['admin','manager']}><ServiceAndChecklist /></ProtectedRoute>} />
          <Route path="/inventory-management" element={<ProtectedRoute allowedRoles={['admin','logistician','manager']}><InventoryManagement /></ProtectedRoute>} />
          <Route path="/interventions-management" element={<ProtectedRoute allowedRoles={['admin','manager']}><Interventionmanagement /></ProtectedRoute>} />
          <Route path="/public-service-tracking" element={<ProtectedRoute allowedRoles={['admin','dispatch','technicien','trainer','client']}><PublicServiceTracking /></ProtectedRoute>} />
          <Route path="/mes-devis" element={<ProtectedRoute allowedRoles={['admin','dispatch','technicien','trainer','client']}><MesDevisPage /></ProtectedRoute>} />
          <Route path="/devis" element={<PublicQuotePage />} />
          <Route path="/quote-accept-booking" element={<QuoteAcceptBookingPage />} />
          <Route path="/login-authentication" element={<LoginAuthentication />} />
          <Route path="/auth/callback" element={<ProtectedRoute allowedRoles={['admin','manager','technicien','trainer','client']}><AuthCallback /></ProtectedRoute>} />
          <Route path="/service-booking-wizard" element={<ServiceBookingWizard />} />
          <Route path="/technician-daily-routes" element={<ProtectedRoute allowedRoles={['admin','dispatch','technicien','trainer']}><TechnicianDailyRoutes /></ProtectedRoute>} />
          <Route path="/customer-account-portal" element={<ProtectedRoute allowedRoles={['admin','dispatch','technicien','trainer','client']}><CustomerAccountPortal /></ProtectedRoute>} />
          <Route path="/user-management" element={<ProtectedRoute allowedRoles={['admin','dispatch']}><UserManagement /></ProtectedRoute>} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/cgv" element={<CgvPage />} />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export { Routes };